import { IEProvinceName } from '../../constants/province-name/ie-province-name.constant';
import { CountryIsoNumber } from '../../models/country/country-iso-number.enum';

export function provinceNamesFactory(
  countryIsoNumber?: CountryIsoNumber,
): Map<string, string> | undefined {
  switch (countryIsoNumber) {
    case CountryIsoNumber.Ireland:
      return IEProvinceName;
    case CountryIsoNumber.GreatBritain:
    default:
      return;
  }
}
